import { render, staticRenderFns } from "./BrebImage.vue?vue&type=template&id=7e7ae246&scoped=true&"
import script from "./BrebImage.vue?vue&type=script&lang=js&"
export * from "./BrebImage.vue?vue&type=script&lang=js&"
import style0 from "./BrebImage.vue?vue&type=style&index=0&id=7e7ae246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7ae246",
  null
  
)

export default component.exports